import ServiceDetailLayout from '../components/ServiceDetailLayout';
import { serviceDetails } from '@/mocks/service-details';

export default function LandscapingPage() {
  return <ServiceDetailLayout data={serviceDetails.landscaping} />;
}